module.exports = __webpack_public_path__ + "static/media/AB_K2_3.909bfe0e.jpg";